export class BasePath {
    constructor(public rootPath: string) {}

    public subPath(...subs: string[]): string {
        return [this.rootPath].concat(subs).join('/')
    }
}

const NotLoggedInAlbumPath = new BasePath('/a')
const LoggedInAlbumPath = new BasePath('/albums')
const SharePath = new BasePath('/share')
const SelectForExternalPath = new BasePath('/selectPhotos')
const CarouselPath = new BasePath('/carousel')
const TimelinePath = new BasePath('/photos')
const AlbumImageAsShare = new BasePath('/albumImage')
const CollectionsPath = new BasePath('/collections')
const MemoriesPath = new BasePath('/memories')

export type InAppSearchParams = {
    fromNav?: boolean
}

export const FROM_INSIDE_APP_SUB_PATH = '/_from_inside_app'

export const RoutePath = {
    Me: '/me',
    Timeline: '/photos',
    Albums: '/albums',
    TrashNavigation: '/deleted_items',
    TrashPhotos: '/deleted_items/photos',
    TrashAlbums: '/deleted_items/albums',
    InAppTrashNavigation: `${FROM_INSIDE_APP_SUB_PATH}/deleted_items`,
    Documents: '/documents',
    Settings: '/settings',
    SettingsPrivacy: '/settings/privacy',
    SettingsTakeout: '/settings/takeout',
    SettingsUnsubscribe: '/settings/unsubscribe',
    InAppPrivacySettings: `${FROM_INSIDE_APP_SUB_PATH}/settings/privacy`,
    SettingsStorage: '/settings/storage',
    SettingsLoggedInDevices: '/settings/devices',
    EmailSettings: '/emailSettings',
    Help: '/help',
    SelectForExternalStart: '/selectPhotos',
    SelectProfilePicture: '/selectProfilePicture',
    Collection: CollectionsPath.rootPath,
    getInAppTrashPhotosPath: (searchParams?: InAppSearchParams) =>
        `${FROM_INSIDE_APP_SUB_PATH}/deleted_items/photos` +
        (searchParams?.fromNav ? '?fromNav=1' : ''),
    getInAppTrashAlbumsPath: (searchParams?: InAppSearchParams) =>
        `${FROM_INSIDE_APP_SUB_PATH}/deleted_items/albums` +
        (searchParams?.fromNav ? '?fromNav=1' : ''),
    getAlbumImageAsSharePath: (aIDParam: string, fIDParam: string) =>
        AlbumImageAsShare.subPath(aIDParam, fIDParam),
    getNotLoggedInAlbumPath: (aIDParam: string) =>
        NotLoggedInAlbumPath.subPath(aIDParam),
    getLoggedInAlbumPath: (aIDParam: string) =>
        LoggedInAlbumPath.subPath(aIDParam),
    getCollectionPath: (cIDParam: string) => CollectionsPath.subPath(cIDParam),
    getEditAlbumPath: (aIDParam: string, goToAfter: string) =>
        LoggedInAlbumPath.subPath(aIDParam, 'edit', goToAfter),
    getCreateAlbumLoginPath: (aIDParam: string) =>
        NotLoggedInAlbumPath.subPath(aIDParam, 'createNew'),
    getSubscribeToAlbumLoginPath: (aIDParam: string) =>
        NotLoggedInAlbumPath.subPath(aIDParam, 'subscribe'),
    getCopyAlbumLoginPath: (aIDParam: string) =>
        NotLoggedInAlbumPath.subPath(aIDParam, 'copyAlbum'),
    getCopyAlbumFileLoginPath: (aIDParam: string, fIDParam: string) =>
        NotLoggedInAlbumPath.subPath(aIDParam, fIDParam, 'copyAlbum'),
    getAlbumFileCommentsPath: (aIDParam: string, fIDParam: string) =>
        new BasePath('/comments').subPath(aIDParam, fIDParam),
    morePhotosCreateAlbum: (aIDParam: string) =>
        LoggedInAlbumPath.subPath(aIDParam, 'edit/addPhotos'),
    morePhotosAlbum: (aIDParam: string) =>
        new BasePath('/addPhotos').subPath(aIDParam),
    getShareReceiverPath: (sIDParam: string) => SharePath.subPath(sIDParam),
    getCopyShareLoginPath: (sIDParam: string) =>
        SharePath.subPath(sIDParam, 'copyShare'),
    getAlbumCarouselPath: (aIDParam: string, fIDParam: string) =>
        CarouselPath.subPath(aIDParam, fIDParam),
    getTimelineCarouselPath: (fIDParam: string) =>
        TimelinePath.subPath(fIDParam),
    getSelectForExternalEndPath: (jobSourceParam: string) =>
        SelectForExternalPath.subPath(jobSourceParam),
    getErrorPath: (errorParam: string) => `/error/${errorParam}`,
    getCollectionCarouselPath: (
        cIDParam: string,
        options: { index?: number; highlights?: boolean } = {},
    ) => {
        const basePath = CollectionsPath.subPath(cIDParam, 'carousel')

        const queryString = Object.entries(options)
            .filter(([_, value]) => value !== undefined)
            .map(([key, value]) => `${key}=${value}`)
            .join('&') // Join with '&'

        return queryString ? `${basePath}?${queryString}` : basePath
    },
    getMemoryCarouselPath: (dateRange: string) => {
        return MemoriesPath.subPath(dateRange, 'carousel')
    },
}
